import { BentoStaticData } from './types';

export const BENTO_TYPES = {
  MAIN: 'main',
  VEGETARIAN: 'vegetarian',
};

export const LABEL_BY_BENTO_TYPE = {
  [BENTO_TYPES.MAIN]: 'Non-Vegan Bentos',
  [BENTO_TYPES.VEGETARIAN]: 'Vegan-Friendly Bentos',
};

export const BENTO_STATIC_DATA: BentoStaticData = {
  images: [
    '/images/static/catering/product/bento/bento1.jpg',
    '/images/static/catering/product/bento/bento2.jpg',
    '/images/static/catering/product/bento/bento3.jpg',
    '/images/static/catering/product/bento/bento4.jpg',
    '/images/static/catering/product/bento/bento5.jpg',
    '/images/static/catering/product/bento/bento6.jpg',
    '/images/static/catering/product/bento/bento7.jpg',
  ],
  prologue:
    'Our bentos take the hassle out of meal distribution—clean, macro-friendly, and loaded with bold flavours that hit the spot. Individually packed for easy portion control, plus tasty vegan options to suit every taste. Perfect for any occasion!',
  pricing: [
    '<em>No minimum quantity for vegan-friendly SKUs, but must be ordered alongside other catering products.</em>',
    'Orders of 50 bentos and above enjoy a discount of $1.00 OFF each bento.',
  ],
  deliveryFee: {
    cbd: 50,
    nonCbd: 40,
    basePrice: 40,
  },
  basePriceLimit: 0,
  minBulkOrder: 50,
  main: {
    title: 'Non-Vegan Bentos',
    description: 'Min. 10 Bentos per SKU',
    minOrder: 10,
    items: [
      {
        name: 'Yummy Kopi Chicken Set',
        description:
          'A bold, energising meal of kopi-marinated chicken, fragrant sesame garlic wholemeal penne, and Asian greens.',
        price: 15.9,
        bulkPrice: 14.9,
      },
      {
        name: 'Yummy Sambal Fish Set',
        description:
          'A spicy option with house-made sambal fish, YB Green Low GI Nasi Lemak Rice, turmeric cauliflower, long beans, and a garnish of chopped spring onions.',
        price: 15.9,
        bulkPrice: 14.9,
      },
      {
        name: 'Zesty Fish Set',
        description:
          "Baked sutchi fish paired with sweet potatoes, vegetables, and a rich butter, cream and lemon sauce inspired by Norway's classic Sandefjordsmør.",
        price: 15.9,
        bulkPrice: 14.9,
      },
      {
        name: 'Ginger Soy Salmon Set',
        description:
          'Tender ginger soy salmon cubes with steamed red and brown rice, braised mushrooms, and Chinese cabbage for a wholesome Asian-inspired meal.',
        price: 15.9,
        bulkPrice: 14.9,
      },
      {
        name: 'Honey Soy Chicken Yam Rice Set',
        description:
          'Juicy baked honey soy chicken glazed in a sweet and savoury sauce, paired with steamed brown yam rice, pumpkin, and xiao bai cai.',
        price: 15.9,
        bulkPrice: 14.9,
      },
      {
        name: 'Roasty Chicken Pasta Set',
        description:
          'A hearty Western-style meal of Cajun-roasted chicken, whole wheat spaghetti, mushrooms, and rainbow bell peppers.',
        price: 15.9,
        bulkPrice: 14.9,
      },
      {
        name: 'Hainanese Chicken Rice Set',
        description:
          'Tender steamed chicken breast served with fragrant Low GI chicken rice, braised egg, gai lan, and our signature chilli and ginger sauces.',
        price: 15.9,
        bulkPrice: 14.9,
      },
      {
        name: 'Yummy Chicken Kolomee Set',
        description:
          'Inspired by Sarawak Kolomee, this dish features tender char siew chicken, kolomee, braised mushrooms, greens, and house-made sambal.',
        price: 15.9,
        bulkPrice: 14.9,
      },
      {
        name: 'Beefy Ban Mian Bolognese Set',
        description:
          'Rich tomato bolognese, savoury minced beef, brown rice ban mian, mushrooms, and broccoli come together in this comforting Western-inspired favourite.',
        price: 18.9,
        bulkPrice: 17.9,
        additionalPrice: 3,
      },
      {
        name: 'Yummy Beef Kway Teow Set',
        description:
          'Aromatic ginger scallion beef served with wholegrain kway teow, gai lan, carrots, and Chinese cabbage for a healthier take on a local favourite.',
        price: 18.9,
        bulkPrice: 17.9,
        additionalPrice: 3,
      },
      {
        name: 'Yummy Beef Rendang Set',
        description:
          'An indulgent beef rendang infused with aromatic spices, served with lemongrass Low GI basmati rice, sambal long beans, and turmeric cauliflower.',
        price: 18.9,
        bulkPrice: 17.9,
        additionalPrice: 3,
      },
      {
        name: 'Yummy Chicken Bulgogi Set',
        description:
          'Our best-selling chicken bulgogi, made with lean minced breast and served with red-brown rice, Chinese cabbage, and stir-fried carrots.',
        price: 15.9,
        bulkPrice: 14.9,
      },
    ],
  },
  vegetarian: {
    title: 'Vegan-Friendly Bentos',
    description:
      'No minimum quantity, but must be ordered with other catering items.',
    minOrder: 0,
    items: [
      {
        name: 'Spicy Tofu Set',
        description:
          'A wholesome plant-based meal featuring spicy silken tofu, nutrient-rich gai lan, and Chinese cabbage with shredded carrots, served with fluffy Low GI basmati rice.',
        price: 15.9,
        bulkPrice: 14.9,
      },
      {
        name: 'Yummy Baked Tofu Set (Non-Spicy)',
        description:
          'A deliciously nourishing meal featuring baked tofu, rainbow pepper whole wheat spaghetti aglio olio, and wholesome stir-fried vegetables.',
        price: 15.9,
        bulkPrice: 14.9,
      },
      {
        name: 'Yummy Herbal Mushrooms Rice Set (Non-spicy)',
        description:
          'A comforting blend of herbal white shimeiji, oyster, and Chinese mushrooms paired with steamed red and brown rice, pumpkin, and broccoli.',
        price: 15.9,
        bulkPrice: 14.9,
      },
    ],
  },
};
